import 'babel-polyfill';
import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import AuthStore from './modules/AuthStore';
import moment from "moment";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    auth: AuthStore,
  },
  state: {
    subscriptions: [],
    subscriptionsFailed: false,
    isLoading: false,
    pauseDate: null,
    avalancheRegions: [],
    municipalities: [],
    counties: [],
    rockslideObjects: [],
    subscriptionTypes: [],
    images: [],
    isInitialized: false,
    baseUserProfileUri: window.location,
    urls: {
      varsomUrl: "https://www.varsom.no",
      metUrl: "https://www.met.no/vaer-og-klima/ekstremvaervarsler-og-andre-farevarsler"
    }
  },
  computed: {
    isInitialized(getters) {
      return getters.isInitialized;
    }
  },
  mutations: {
    setAvalancheRegions(state, regions) {
      state.avalancheRegions = regions;
    },
    setMunicipalities(state, municipalities) {
      state.municipalities = municipalities;
    },
    setCounties(state, counties) {
      state.counties = counties;
    },
    setRockslideObjects(state, objects) {
      state.rockslideObjects = objects
    },
    setSubscriptionTypes(state, subscriptionTypes) {
      state.subscriptionTypes = subscriptionTypes;
    },
    setSubscriptions(state, subscriptions) {
      state.subscriptions = subscriptions;
    },
    setSubscriptionsFailed(state, hasFailed) {
      state.subscriptionsFailed = hasFailed;
    },
    setIcons(state, icons) {
      state.images = icons;
    },
    setPauseDate(state, date) {
      state.pauseDate = date;
    },
    setUserProfileUri(state, uri) {
      if (uri.indexOf("returnUrl") < 0) {
        uri = uri + '?returnUrl=';
      }
      state.baseUserProfileUri = uri;
    },
    setVarsomUrl(state, url) {
      state.urls.varsomUrl = url;
    },
    setMetUrl(state, url) {
      state.urls.metUrl = url;
    },
    setIsLoading(state, isLoading){
      state.isLoading = isLoading;
    },
    setIsInitialized(state, isInitialized){
      state.isInitialized = isInitialized;
    }

  },
  getters: {
    isInitialized(state) {
      return state.isInitialized;
    },
    isLoading(state) {
      return state.isLoading;
    },
    varsomUrl(state) {
      return state.urls.varsomUrl;
    },
    metUrl(state) {
      return state.urls.metUrl;
    },
    disableSMS(modules) {
      return !(modules.auth.user && modules.auth.user.enableSMS);
    },
    user(modules) {
      return modules.auth.user;
    },
    userId(modules) {
      return modules.auth.user.accountIdentifier;
    },
    userLoggedIn(modules) {
      return modules.auth.isAuthenticated;
    },
    userName(modules) {
      return modules.auth.user.name;
    },
    userProfileUri(state) {      
      return state.baseUserProfileUri + window.location.href;
    },
    pauseDate(state) {
      return state.pauseDate;
    },
    userSubscriptionsFailed(state) {
      return state.subscriptionsFailed;
    },
    userSubscriptions(state) {
      return state.subscriptions;
    },
    hasSubscriptions(state, getters) {
      const subs = getters.userSubscriptions;
      if (!subs || subs.length == 0) return false;
      return true;
    },
    activeSubscriptions(state, getters) {
      const subs = getters.userSubscriptions;
      if (!subs || subs.length == 0) return [];
      const enabledSubs = subs.filter((a) => a.isEnabled);
      return enabledSubs;
    },
    hasActiveSubscriptions(state, getters) {
      const activeSubs = getters.activeSubscriptions;
      const hasActiveSubs = activeSubs.length > 0;
      return hasActiveSubs;
    },
    onlyInactiveSubscriptions(state, getters) {
      return getters.hasSubscriptions && !getters.hasActiveSubscriptions;
    },
    avalancheRegions(state) {
      return state.avalancheRegions;
    },
    counties(state) {
      return state.counties;
    },
    municipalities(state) {
      return state.municipalities;
    },
    subscriptionTypes(state) {
      return state.subscriptionTypes;
    },
    rockslideObjects(state) {
      return state.rockslideObjects;
    },
    images(state) {
      return state.images;
    }
  },
  actions: {
    async initApplicationData({ dispatch }
    ) {
      try {
        await Promise.all([
          dispatch('getIcons')
        ]);
      } catch (ex) {
        //eslint-disable-next-line
        console.error(ex);
      }
    },
    async logout() {
      this.dispatch('auth/logout');
    },
    async getSubscriptions({ commit, getters }) {
      if (!getters.userLoggedIn || getters.isLoading) return;
      commit('setIsLoading', true);

      try {
        var result = await axios.get(`/api/api/subscription/GetUserSubscriptions`);
        const subscriptions = result.data;

        let pauseMoment = null;
        const pausedWithDate = subscriptions.filter((s) => s.pauseDate);
        if (pausedWithDate.length > 0) {
          pauseMoment = moment(pausedWithDate[0].pauseDate);
        }

        commit('setPauseDate', pauseMoment);
        commit('setSubscriptions', subscriptions);
        commit('setSubscriptionsFailed', false);
      } catch (ex) {
        //eslint-disable-next-line
        console.error(`Unable to load user subscriptions. Error was ${ex.message}`);
        //eslint-disable-next-line
        console.error(ex);
        commit('setSubscriptionsFailed', true);
      } finally {
        commit('setIsLoading', false);
      }
    },
    requireIcons() {
      var importAll = function (r) {
        return r.keys().map(r);
      };
      return new Promise((resolve, reject) => {
        try {
          var icons = importAll(
            require.context("../assets/yr-icons", false, /\.(png|jpe?g|svg)$/)
          );
          resolve(icons);
        }
        catch (ex) {
          reject(ex);
        }
      });
    },
    async getIcons({ commit, dispatch }) {
      try {
        var icons = await dispatch('requireIcons');
        commit('setIcons', icons);
      } catch (ex) {
        //eslint-disable-next-line
        console.error(ex);
      }

    }
  }
});

export default store;
